import { THEME_PREFIX } from './config'

export function isPlainObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]'
}

export function toCssVarName(key) {
  const v = String(key || '').trim()
  if (!v) return ''

  return v.startsWith('--') ? v : `${THEME_PREFIX}${v}`
}

export function hexToRgba(hex, alpha) {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}



// WEBPACK FOOTER //
// ./src/layout/layout/setup/theme-system/utils.js